import angular from 'angular';
import {
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  utilityService
} from 'app/services';
import { alerts as alertService } from 'app/components/global';
import controller from './training-document.controller';
import directive from './training-document.directive';


export default angular.module('app.components.support.trainingDocument', [
  ssDialogService,
  alertService,
  userService,
  loaderService,
  orgDataService,
  utilityService
])
  .directive('trainingDocument', directive)
  .controller('TrainingDocumentController', controller)
  .name;

console.log('app.components.support.trainingDocument created');
